import React, { useEffect, useState } from "react";
import axios from "axios";
import { useParams } from "react-router-dom";
import { Button, Col, Row, Stack } from "react-bootstrap";
import { faArrowUpRightFromSquare } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import TimelineSessionStart from "./timeline/TimelineSessionStart";
import TimelineSubmitStruct from "./timeline/TimelineSubmitStruct";
import TimelineResult from "./timeline/TimelineResult";
import TimelineFinish from "./timeline/TimelineFinish";
import TimelineDivider from "./timeline/TimelineDivider";
import DraftSubmissions from "./DraftSubmissions";

export default function CaseDetails(props) {
  const [cs, setCase] = useState(null);
  const [timeLineObject, setTimeLine] = useState(null);

  let { studentnumber } = useParams();

  useEffect(() => {
    loadDetails();
    // eslint-disable-next-line
  }, [props.id]);

  function loadDetails() {
    axios
      .get("/api/student/" + studentnumber + "/case/" + props.id, {
        withCredentials: false,
      })
      .then((response) => {
        const cs = response.data;
        setCase(response.data);
        const timeLineArray = [];
        cs.sessions.forEach((session, index) => {
          timeLineArray.push({
            date: session.createdOn,
            component: (
              <TimelineSessionStart
                data={{ session: session, index: index + 1 }}
              />
            ),
          });
          if (!submissionInSession(cs, session)) {
            if (new Date(cs.deadline) >= new Date())
              timeLineArray.push({
                date: session.createdOn,
                component: (
                  <TimelineSubmitStruct
                    data={{
                      caseId: response.data.id,
                      session: session.id,
                      studentNumber: studentnumber,
                      callback: loadDetails,
                    }}
                  />
                ),
              });
          } else {
            cs.submissions.forEach((submission) => {
              if (session.id === submission.session.id) {
                timeLineArray.push({
                  date: submission.createdOn,
                  component: <TimelineResult data={submission} />,
                });
              }
            });
          }
          if (new Date(cs.deadline) < new Date()) {
            timeLineArray.push({
              date: cs.deadline,
              component: <TimelineFinish />,
            });
          }
        });
        timeLineArray.reverse();
        // timeLineArray.sort(function(a, b) {
        //     return new Date(a.date).getTime() - new Date(b.date).getTime();
        // }).reverse()
        setTimeLine(timeLineArray);
      })
      .catch((err) => {
        console.error(err);
      });
  }

  function submissionInSession(cs, session) {
    if (!cs || !session) return false;
    for (const submission of cs.submissions) {
      if (session.id === submission.session.id) {
        return true;
      }
    }

    return false;
  }

  if (cs) {
    return (
      <div style={{ height: "100%" }}>
        <Row style={{ height: "100%" }}>
          <Col className="position-relative" xs={5}>
            <h4>{cs.name}</h4>
            <small>Deadline: {new Date(cs.deadline).toLocaleString()}</small>
            <br />
            <small>Module: {cs.module.name}</small>
            <br />
            <small>Students: {cs.module.studentCount}</small>
            <br />

            <p className="mt-5">
              <b>Description:</b>
            </p>
            <p>{cs.description}</p>

            <DraftSubmissions caseId={cs.id} studentNumber={studentnumber} />

            <div
              className="d-grid gap-2"
              style={{
                position: "absolute",
                bottom: 0,
                left: 0,
                right: 0,
                padding: 10,
              }}
            >
              <Button href={cs.atlas} target="_blank" variant="secondary">
                Atlas
                <FontAwesomeIcon icon={faArrowUpRightFromSquare} />
              </Button>
            </div>
          </Col>
          <Col
            xs={7}
            className="position-relative"
            style={{
              overflowY: "scroll",
              borderLeft: "solid",
              height: "calc(100vh - 140px)",
            }}
          >
            <Stack
              gap={4}
              className="mx-auto align-items-center justify-items-center "
            >
              {timeLineObject.map((obj, index) => (
                <div
                  className="d-flex flex-column align-items-center "
                  key={index}
                >
                  {" "}
                  {index ? <TimelineDivider /> : null}
                  {obj.component}
                </div>
              ))}
            </Stack>
          </Col>
        </Row>
      </div>
    );
  }
  return <h3>Loading....</h3>;
}
